const RequestOrdersSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="none">
            <rect width="26.019" height="26.019" x=".063" y=".285" fill="#fff" fillOpacity=".3" rx="6"/>
            <path fill="#546EDB" fillRule="evenodd" d="M10.495 7.69v.296c.17.067.33.174.467.32l.933.99a1.462 1.462 0 0 1 0 1.981l-1.98 2.102a1.898 1.898 0 0 1-2.72.08v1.236c0 1.547 1.182 2.802 2.64 2.802h5.668l2.447 2.597c.189.2.473.26.72.152a.704.704 0 0 0 .407-.648v-9.106c0-1.547-1.183-2.802-2.64-2.802h-5.942Zm-2.64 2.512L7 9.296l-.934.99 1.98 2.102a.633.633 0 0 0 .934 0l1.98-2.101-.933-.99-.853.905V6.289h-1.32v3.913Z" clipRule="evenodd"/>
            <circle cx="17.075" cy="12.293" r="1.001" fill="#6FE1B8"/>
            <circle cx="14.073" cy="12.293" r="1.001" fill="#6FE1B8"/>
        </svg>
    )
}

export default RequestOrdersSvg;